import { useLoanApplication } from '@axo/shared/data-access/hooks';
import { AceCard } from '../AceCard';
import { NonIdealState, Spinner } from '@blueprintjs/core';
import { DataFetchedFrom } from '@axo/shared/data-access/types';
import styles from './ETaxCard.module.css';

interface ETaxCardProps {
  applicationID: string;
}

export const ETaxCard: React.FC<ETaxCardProps> = ({ applicationID }) => {
  const { data: applicationData, isLoading: isLoadingApplicationData } =
    useLoanApplication(applicationID);

  const hasETaxData =
    applicationData?.DataFetchedFrom === DataFetchedFrom.Uniify;

  return (
    <AceCard
      key={`ETax.${applicationID}`}
      id={`ETax.${applicationID}`}
      title="E-Tax"
      noBorder
      noContentPadding
      isExpandedByDefault
    >
      {isLoadingApplicationData ? (
        <Spinner />
      ) : (
        <>
          {!hasETaxData && (
            <NonIdealState
              icon="warning-sign"
              title="Customer has not given consent to E-Tax"
              className={styles.nonIdealStatePadding}
            />
          )}
          {hasETaxData && (
            <NonIdealState
              icon="tick-circle"
              title="Customer has given consent to E-Tax"
              className={styles.nonIdealStatePadding}
            />
          )}
        </>
      )}
    </AceCard>
  );
};
